import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Member, ReportingUnit, Restaurant } from '../models';
import { State, toDataSourceRequestString } from '@progress/kendo-data-query';
import { ListViewDataResult } from '@progress/kendo-angular-listview';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { GridState } from '@shared';

@Injectable()
export class RestaurantService {
  private apiUrl: string = environment.apiUrl + '/restaurants';

  constructor(private httpClient: HttpClient) {}

  getTieredRestaurants(state: State): Observable<ListViewDataResult> {
    const url = `${this.apiUrl}/tiered?${toDataSourceRequestString(state)}`;
    return this.httpClient.get<ListViewDataResult>(url);
  }

  getUntieredRestaurants(state: State): Observable<ListViewDataResult> {
    const url = `${this.apiUrl}/untiered?${toDataSourceRequestString(state)}`;
    return this.httpClient.get<ListViewDataResult>(url);
  }

  updateRestaurant(restaurant: Restaurant) {
    return this.httpClient.put(`${this.apiUrl}/${restaurant.id}`, restaurant);
  }

  updateBulkRestaurants(restaurants: Restaurant[]) {
    return this.httpClient.put(`${this.apiUrl}/bulk`, restaurants);
  }

  setKingRestaurant(restaurantId: string) {
    return this.httpClient.get(`${this.apiUrl}/${restaurantId}/setKing`);
  }

  getMemberRestaurants(reportingUnit?: number): Observable<Restaurant[]> {
    let params = new HttpParams();

    if (reportingUnit !== undefined && reportingUnit !== null) {
      params = params.append('reportingUnit', reportingUnit.toString());
    }

    return this.httpClient.get<Restaurant[]>(
      `${this.apiUrl}/member/restaurants`,
      { params },
    );
  }
  getParTokenRestaurants(reportingUnit?: number): Observable<Restaurant[]> {
    const url = `${this.apiUrl}/partoken`;
    if (reportingUnit !== undefined) {
      return this.httpClient.get<Restaurant[]>(
        `${url}?reportingUnit=${reportingUnit}`,
      );
    }

    return this.httpClient.get<Restaurant[]>(url);
  }

  getAllRestaurants(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}/all?${toDataSourceRequestString(state)}`,
    );
  }

  getRestaurants(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}?${toDataSourceRequestString(state)}`,
    );
  }

  createRestaurant(restaurant: Restaurant): Observable<Restaurant> {
    return this.httpClient.post<Restaurant>(this.apiUrl, restaurant);
  }

  updateParToken(id: number, partoken?: any): Observable<any> {
    return this.httpClient.put(
      `${this.apiUrl}/update/${id}?parToken=${encodeURIComponent(partoken)}`,
      {},
    );
  }

  getMembers(state: GridState): Observable<GridDataResult> {
    const url = `${this.apiUrl}/members?${toDataSourceRequestString(state)}`;
    return this.httpClient.get<GridDataResult>(url);
  }

  getReportingUnits(state: GridState): Observable<GridDataResult> {
    const url = `${this.apiUrl}/reporting-units?${toDataSourceRequestString(state)}`;
    return this.httpClient.get<GridDataResult>(url);
  }
}
